<template>
  <div class="holder">
    <div class="text-sm mb-1 opacity-50" v-if="label">
      {{ innerLabel }}
    </div>
    <input
      v-if="mask"
      type="text"
      v-model.trim="innerValue"
      :placeholder="placeholder"
      :readonly="readonly"
      @blur="onBlur"
      @focus="onFocus"
      @keydown.enter="$emit('enter', $event)"
      v-mask="{ mask, placeholder: ' ', showMaskOnHover: false }"
      class="!text-left"
      :class="{
        uppercase: uppercase
      }"
    />
    <input
      v-else
      type="text"
      v-model.trim="innerValue"
      :placeholder="placeholder"
      :readonly="readonly"
      @blur="onBlur"
      @focus="onFocus"
      @keydown.enter="$emit('enter', $event)"
      :class="{
        uppercase: uppercase
      }"
    />
  </div>
</template>

<script>
export default {
  name: 'uiInput',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    mask: {
      type: String,
      default: undefined
    },
    label: [Boolean, String],
    units: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    uppercase: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      innerValue: this.value
    }
  },
  computed: {
    innerLabel () {
      if (!this.label) return
      if (typeof this.label === 'string') return this.label
      return this.placeholder
    }
  },
  watch: {
    value (newVal) {
      this.innerValue = this.uppercase ? newVal.toUpperCase() : newVal
    },
    innerValue (newVal) {
      this.$emit('input', newVal)
    }
  },
  methods: {
    onBlur () {
      this.$forceUpdate()
      this.$emit('blur', this.innerValue)
    },
    onFocus () {
      this.$emit('focus', this.innerValue)
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/app.less';

.holder {
  width: 100%;
  display: block;
}

input {
  display: block;
  width: 100%;
  padding: 0 20px;
  height: 48px;
  background-color: transparent;
  border: none;
  background: @grey;
  border-radius: 10px;
  font-size: 15px;
  box-sizing: border-box;
  outline: none;

  &::placeholder {
    color: rgba(0, 0, 0, 0.3);
    transition: color 0.2s;
  }

  &:focus {
    &::placeholder {
      color: transparent;
    }
  }
}
</style>
